import React from "react";
import { BadgeCheck } from "lucide-react";

// On-brand verified check (green gradient). Shown next to a verified coin's symbol/name.
export default function VerifiedCheck({ size = 16, className = "", withLabel = false }) {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} title="Verified creator — paid on-chain verification" data-testid="verified-check">
      <svg width="0" height="0" className="absolute">
        <linearGradient id="verifiedGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1EC62E" />
          <stop offset="100%" stopColor="#7CF24E" />
        </linearGradient>
      </svg>
      <BadgeCheck size={size} style={{ stroke: "url(#verifiedGrad)" }} className="shrink-0" />
      {withLabel && <span className="text-[10px] font-bold uppercase tracking-wide text-[#1EC62E]">Verified</span>}
    </span>
  );
}
